import React from 'react';
import { Spinner, Container } from 'react-bootstrap';

const LoadingSpinner = ({ centered = true }) => {
    if (centered) {
        return (
            <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                <Spinner animation="border" role="status" className="text-amber">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </Container>
        );
    }

    return (
        <Spinner animation="border" role="status" className="text-amber">
            <span className="visually-hidden">Loading...</span>
        </Spinner>
    );
};

export default LoadingSpinner;
